import styled from 'styled-components';

export const BreadcrumbWrapper = styled.div`
  [class*='Breadcrumbsstyle__BreadcrumbsItem-sc'] {
    a {
      text-decoration: underline !important;
    }
  }
`;